import axios from "../../../axios";
import React, { useState } from "react";
import "./editDelete.css";
import { useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import { Check, Close } from "@mui/icons-material";

const EditComment = ({
  setComments,
  commentData,
  setClickEditComment,
  setEdited,
  post_id,
  setIsCommented,
  setIsInProgress,
  isCommented,
  getPostComme

}) => {
  const [updateComment, setUpdateComment] = useState(commentData?.comment);

  const user_id = useSelector((state) => state.user.currentUser.id);

  const handleClick = async () => {
    setIsInProgress(true)
    try {
      const res = await axios.put(
        `/community/post/${post_id}/comment/update/${commentData?.id}`,
        {
          user_id,
          comment: updateComment,
        }
      );
      if (res) {
        setIsInProgress(false)
        setEdited(true);
        setComments([]);
        setClickEditComment(false);
        await getPostComme();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsInProgress(false)
    }
  };

  return (
    <>
      <div className="flex flex-row gap-2 w-100 my-2">
        <textarea
          value={updateComment}
          onChange={(e) => setUpdateComment(e.target.value)}
          rows={3}
          className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
          placeholder="Edit your comment..."
        />

        <div className="flex gap-2 justify-end">
          <IconButton size="small" color="success" onClick={handleClick}>
            <Check fontSize="small" />
          </IconButton>

          <IconButton
            size="small"
            color="error"
            onClick={() => setClickEditComment(false)}
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
      </div>
    </>
  );
};
export default EditComment;
